import { FaCheckCircle, FaEye, FaFilePdf, FaWifi } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import DistributionDropdown from "../../CorporateAction/DistributionModeDropdown";

// Utilitaires
import { 
  formatAmountInThousands, 
  formatDate, 
  getEventStatus, 
  getBadgeClass, 
  getDateStyle 
} from "../../service/utils/formatters";

/**
 * COMPOSANT LIGNE DU TABLEAU - Gère l'affichage offline
 */
const EventTableRow = ({ 
  event, 
  onComplete, 
  onGenerateReport, 
  onShowDetails,
  onDistributeClick,
  isOffline = false
}) => {
  const displayStatus = getEventStatus(event);
  const canDistribute = displayStatus === "Pending" && !isOffline; // Bloqué si offline

  return (
    <tr className={isOffline ? 'row-offline' : ''}>
      <td>{event.type}</td>
      
      <td className="py-2 text-center">
        <span className="counter-amount-badge">
          {event.amount ? formatAmountInThousands(event.amount) : "N/A"}
        </span>
      </td>
      
      <td className="py-2 text-center">
        <span className="counter-amount-badge">
          {event.nombreTitre ? (event.nombreTitre) : "N/A"}
        </span>
      </td>
      
      <td>
        <span className="counter-amount-badge">
          {event.capital ? `${(event.capital)} %` : "N/A"}
        </span>
      </td>
      
      <td>{event.securityName}</td>
      
      <td className="text-center">{event.targetMarket}</td>
      
      <td style={getDateStyle(event.dateDePlanification)}>
        {formatDate(event.dateDePlanification)}
      </td>
      
      <td>{formatDate(event.dateDeRealisation)}</td>
      
      <td>
        <span className={getBadgeClass(displayStatus)}>
          {displayStatus}
        </span>
      </td>
      
      {/* Colonne Distribution - Désactivée si offline */}
      <td className="text-center">
        {canDistribute ? (
          <DistributionDropdown 
            onDistributeClick={onDistributeClick}
            event={event}
          />
        ) : isOffline ? (
          <div className="offline-action-indicator" data-tooltip-id={`offline-tooltip-${event.id}`} data-tooltip-content="Indisponible hors ligne">
            <FaWifi size={16} color="#9CA3AF" style={{ opacity: 0.5 }} />
          </div>
        ) : (
          <span className="text-muted">-</span>
        )}
        <Tooltip id={`distribute-tooltip-${event.id}`} place="top" effect="solid" />
        <Tooltip id={`offline-tooltip-${event.id}`} place="top" effect="solid" />
      </td>
      
      {/* Colonne Actions */}
      <td>
        {displayStatus === "Partially" && !isOffline && (
          <FaCheckCircle
            size={30}
            color="green"
            onClick={() => onComplete(event.id)}
            style={{ cursor: "pointer" }}
            data-tooltip-id={`tooltip-${event.id}`}
            data-tooltip-content="Compléter l'événement"
          />
        )}

        {displayStatus === "Processed" && !isOffline && (
          <>
            <FaFilePdf
              size={30}
              color="red"
              onClick={() => onGenerateReport(event.id)}
              style={{ cursor: "pointer" }}
              data-tooltip-id={`tooltip-${event.id}`}
              data-tooltip-content="Télécharger l'avis de paiement"
            />
          </>
        )}
    
        {/* Détails toujours disponibles même offline (si données en cache) */}
        <FaEye
          size={30}
          color={isOffline ? "#9CA3AF" : "green"}
          onClick={() => !isOffline && onShowDetails(event)}
          style={{ 
            cursor: isOffline ? "not-allowed" : "pointer", 
            marginLeft: "12px",
            opacity: isOffline ? 0.5 : 1
          }}
          data-tooltip-id={`tooltip-${event.id}`}
          data-tooltip-content={isOffline ? "Indisponible hors ligne" : "Détails sur l'événement"}
        />
        
        {/* Indicateur offline pour les actions bloquées */}
        {isOffline && (displayStatus === "Partially" || displayStatus === "Processed") && (
          <span className="offline-actions-badge">
            <FaWifi size={10} />
          </span>
        )}
        
        <Tooltip id={`tooltip-${event.id}`} place="top" effect="solid" />
      </td>
    </tr>
  );
};

export default EventTableRow;